
import { AttendanceMonthRequest, OverTimeRequest, OverTimeResponse } from "@gtpl/shared-models/hrms";
import { CommonResponse } from "@gtpl/shared-models/masters";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Body, Controller, Post } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import { OTStatusRequest } from "./dto/over-time-status.request";
import { OvertimeService } from "./over-time.service";

@ApiTags('over-time')
@Controller('over-time')
export class OvertimeController {
    constructor(
        private service: OvertimeService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ) { }

    @Post('/createOverTime')
    async createOTApply(@Body() DTO: OverTimeRequest): Promise<OverTimeResponse> {
        try {
            return await this.service.createOTApply(DTO);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(OverTimeResponse, error);
        }
    }

    @Post('/getOverTimeTableData')
    async getOverTimeTableData(): Promise<CommonResponse> {
        try {
            return await this.service.getOverTimeTableData();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/updateOTStatus')
    async updateOTStatus(@Body() req: OTStatusRequest): Promise<CommonResponse> {
        try {
            return await this.service.updateOTStatus(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getOTHoursByEmployeeCode')
    async getOTHoursByEmployeeCode(@Body() req: AttendanceMonthRequest): Promise<CommonResponse> {
        try {
            return await this.service.getOTHoursByEmployeeCode(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getOTShiftsByEmployeeCode')
    async getOTShiftsByEmployeeCode(@Body() req: AttendanceMonthRequest): Promise<CommonResponse> {
        try {
            return await this.service.getOTShiftsByEmployeeCode(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
}